<template>
  <span class="skeleton-image" :class="className">
    <!-- Kept mounted (v-show) while loading so @load / @error can still fire. -->
    <img
      ref="img"
      v-show="state === 'loaded'"
      class="skeleton-image-img"
      :src="src"
      :alt="alt"
      @load="onLoad"
      @error="onError"
    />
    <span
      v-if="state !== 'loaded'"
      class="skeleton-image-placeholder"
      :class="state === 'error' ? 'is-error' : 'is-loading'"
      aria-hidden="true"
    ></span>
  </span>
</template>

<script lang="ts" src="./skeleton-image.component.ts"></script>
<style scoped lang="scss" src="./skeleton-image.scss"></style>
